import { Component, inject, ElementRef } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { WkDataTableSelectionService } from "@app/shared/components/data-table/item";
import { WkDataTableContextService } from "@components/data-table/data-table-context.service";
import { WkDataTableStoreService } from "@components/data-table/store";
import { WkDataTableColumn, WkDataTableDraggingService } from "@app/shared/components/data-table/column";

@Component({
    selector: "table[wk-data-table-header]",
    templateUrl: "./data-table-header.component.html",
    styleUrls: ["./data-table-header.component.scss", "../data-table-row.scss"],
    imports: [JumpstartComponentsModule, DragDropModule, WkDataTableColumn],
    host: {
        class: "wk-data-table__header",
    },
})
export class WkDataTableHeader<TItem> {
    protected readonly elementRef = inject(ElementRef);

    protected readonly dataTableStore = inject(WkDataTableStoreService);
    protected readonly dataTableContext = inject<WkDataTableContextService<TItem>>(WkDataTableContextService);
    protected readonly dataTableDragging = inject(WkDataTableDraggingService);
    protected readonly dataTableSelection = inject(WkDataTableSelectionService);

    protected readonly hasLockedColumns = this.dataTableStore.hasLockedColumns;
}
